import { authRequest } from './client';
import { type SearchResponse } from './types';

// ─── backoffice-api search client ──────────────────────────────────────────
//
// Thin fetch wrapper around backoffice-api's `GET /v1/search` (Task 17 —
// global search backing the command palette, Task 23). No `@Roles()` on the
// endpoint — any authenticated admin can call it; which of the four groups
// (`invoices`/`merchants`/`transactions`/`addresses`) come back is entirely
// server-side, role-gated per group.

export function search(q: string): Promise<SearchResponse> {
  const query = new URLSearchParams({ q });
  return authRequest<SearchResponse>(`/search?${query.toString()}`);
}
